/**
 * Created by Daniela on 19/10/2016.
 */
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import {editRoute, newRoute} from "../../shared/services/data.service";
import {PlanosFormComponent} from "./plano-form/plano-form.component";
import {PlanoListComponent} from "./plano-list/plano-list.component";

@NgModule({
  imports: [
    RouterModule.forChild([])
  ],
  exports: [
    RouterModule
  ]
})
export class PlanosRoutingModule {}


export const planosRoutes: any[] = [
  {
    path: '',
    component: PlanoListComponent
  },{
    path: editRoute + '/:id',
    component: PlanosFormComponent
  },{
    path: newRoute,
    component: PlanosFormComponent
  }
];



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/planos/planos-routing.module.ts
 **/